<script lang="ts">
	import { onMount } from 'svelte';
	import { Drawer, Button, CloseButton, A } from 'flowbite-svelte';
	import { InfoCircleSolid, ArrowRightOutline } from 'flowbite-svelte-icons';
	import { sineIn } from 'svelte/easing';
	export let data: any = [];

	let rooms: string[] = [];
	let specialOffers: string[] = [];
	let isLoading = false;
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	let activeTab = 'room';
	$: items = data.data;
	let isScrolled = false;
	let hiddenBackdropTrue = true;
	let transitionParams = {
		x: -320,
		duration: 200,
		easing: sineIn
	};
	let hidden6 = true;
	let transitionParamsRight = {
		x: 320,
		duration: 200,
		easing: sineIn
	};
	onMount(() => {
		const handleScroll = () => {
			isScrolled = window.scrollY > 0;
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	});
	// Function untuk mengambil data dari API
	async function fetchData(url: string) {
		isLoading = true;
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			return data.data; // Sesuaikan dengan struktur data API Anda
		} catch (error) {
			console.error(`Error fetching data from ${url}:`, error);
			return [];
		} finally {
			isLoading = false;
		}
	}

	// Ambil data saat komponen dimuat
	onMount(async () => {
		rooms = await fetchData('https://transresortbali.com/cms/api/v1/room');
		specialOffers = await fetchData('https://transresortbali.com/cms/api/v1/offer');
	});
</script>

<section
	class="hidden lg:block fixed bottom-4 inset-x-4 border border-[#7D704F] rounded-lg z-50 lg:py-5 lg:rounded-none lg:top-0 lg:bottom-auto lg:inset-0 lg:border-0 transition-colors duration-300"
	class:bg-white={isScrolled}
	class:bg-transparent={!isScrolled}
>
	<div class="container mx-auto grid grid-cols-3 items-center px-6">
		<!-- Tombol Menu -->
		<div class="flex items-center me-auto">
			<button
				on:click={() => (hiddenBackdropTrue = false)}
				class="flex items-center gap-x-2 transition-colors"
				class:text-white={!isScrolled}
				class:text-[#7D704F]={isScrolled}
				data-trigger-menu=""
				data-src="#main-menu"
				aria-label="main menu desktop"
			>
				<svg
					class="w-10 h-10 transition-colors"
					class:fill-white={!isScrolled}
					class:fill-[#7D704F]={isScrolled}
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					viewBox="0 0 256 256"
				>
					<path
						d="M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z"
					></path>
				</svg>
				<span></span>
			</button>
		</div>

		<!-- Logo -->
		<div class="flex items-center mx-auto">
			<a data-sveltekit-reload href="/" class="block h-16">
				<img
					class="h-full mx-auto opacity-100 transition-opacity duration-300"
					src={isScrolled ? items[0]?.logo_color[0].path : items[0]?.logo_white[0].path}
					alt={isScrolled ? 'Trans Resort Logo Color' : 'Trans Resort Logo White'}
					loading="lazy"
				/>
			</a>
		</div>

		<!-- Tombol Book Now -->
		<div class="flex items-center ms-auto">
			<a
				data-sveltekit-reload
				href={items[0].book_url}
				class={isScrolled
					? 'uppercase border-[1px] bg-transparent border-[#7D704F] text-[#7D704F] hover:text-white hover:border-[#7D704F] hover:bg-[#7D704F] py-3 px-5 transition-all duration-300'
					: 'uppercase border-[1px] bg-transparent border-white text-white hover:border-[#7D704F] hover:bg-[#7D704F] py-3 px-5 transition-all duration-300'}
			>
				Book Now
			</a>
		</div>
	</div>
	<a
		data-sveltekit-reload
		href={items[0].book_url}
		class="fixed bottom-[110px] left-[17px] right-[17px] bg-[#7D704F] p-2.5 uppercase text-center text-white rounded-[5px] sm:hidden"
		>Book Now</a
	>
</section>

<section
	class="fixed bottom-4 block lg:hidden bg-white inset-x-4 border border-[#7D704F] rounded-lg z-50 lg:py-5 lg:rounded-none lg:top-0 lg:bottom-auto lg:inset-0 lg:border-0"
>
	<a
		data-sveltekit-reload
		href={items[0].book_url}
		class="fixed bottom-[110px] left-[17px] right-[17px] bg-[#7D704F] p-2.5 uppercase text-center text-white rounded-[5px] sm:hidden"
		>Book Now</a
	>
	<div class="container mx-auto p-4 lg:hidden">
		<ul class="flex items-center justify-around mobile-nav">
			<li>
				<a class="nav-item active" data-sveltekit-reload href="/" aria-label="home">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M217.9,110.1l-80-80a14,14,0,0,0-19.8,0l-80,80A13.92,13.92,0,0,0,34,120v96a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V158h36v58a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V120A13.92,13.92,0,0,0,217.9,110.1ZM210,210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46V120a2,2,0,0,1,.58-1.42l80-80a2,2,0,0,1,2.84,0l80,80A2,2,0,0,1,210,120Z"
						></path></svg
					>
				</a>
			</li>
			<li>
				<a class="nav-item" href="/room-villa" aria-label="Read more about our room and villa">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z"
						></path></svg
					>
				</a>
			</li>
			<li>
				<a
					class="nav-item"
					data-sveltekit-reload
					href="/offer"
					aria-label="Check our special offers"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M241.91,137.42,142.59,38.1a13.94,13.94,0,0,0-9.9-4.1H40a6,6,0,0,0-6,6v92.69a13.94,13.94,0,0,0,4.1,9.9l99.32,99.32a14,14,0,0,0,19.8,0l84.69-84.69A14,14,0,0,0,241.91,137.42Zm-8.49,11.31-84.69,84.69a2,2,0,0,1-2.83,0L46.59,134.1a2,2,0,0,1-.59-1.41V46h86.69a2,2,0,0,1,1.41.59l99.32,99.31A2,2,0,0,1,233.42,148.73ZM94,84A10,10,0,1,1,84,74,10,10,0,0,1,94,84Z"
						></path></svg
					>
				</a>
			</li>
			<li>
				<a
					data-sveltekit-reload
					class="nav-item"
					href="/dining"
					aria-label="Dining with special offers"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M74,88V40a6,6,0,0,1,12,0V88a6,6,0,0,1-12,0ZM214,40V224a6,6,0,0,1-12,0V174H152a6,6,0,0,1-6-6c0-4.41.68-108.25,59.64-133.51A6,6,0,0,1,214,40ZM202,50c-36.79,24.29-42.82,91.48-43.81,112H202ZM117.92,39a6,6,0,1,0-11.84,2L114,88.48a34,34,0,0,1-68,0L53.92,41a6,6,0,0,0-11.84-2l-8,48A6.61,6.61,0,0,0,34,88a46.06,46.06,0,0,0,40,45.6V224a6,6,0,0,0,12,0V133.6A46.06,46.06,0,0,0,126,88a6.61,6.61,0,0,0-.08-1Z"
						></path></svg
					>
				</a>
			</li>
			<li>
				<button
					class="mobile-menu-trigger"
					on:click={() => (hidden6 = false)}
					aria-label="menu-button"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M128,98a30,30,0,1,0,30,30A30,30,0,0,0,128,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,146Zm0-68A30,30,0,1,0,98,48,30,30,0,0,0,128,78Zm0-48a18,18,0,1,1-18,18A18,18,0,0,1,128,30Zm0,148a30,30,0,1,0,30,30A30,30,0,0,0,128,178Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,226Z"
						></path></svg
					>
				</button>
			</li>
		</ul>
	</div>
</section>
<Drawer
	backdrop={true}
	transitionType="fly"
	divClass="overflow-y-auto z-[999] p-4 bg-white dark:bg-gray-800"
	{transitionParams}
	bind:hidden={hiddenBackdropTrue}
	id="sidebar1"
	class="w-full"
>
	<div class="container mx-auto w-full h-full flex flex-col justify-between p-5 md:p-10">
		<div class="lg:flex lg:items-center lg:justify-between">
			<div class="hidden lg:block">
				<button
					on:click={() => (hiddenBackdropTrue = true)}
					title="Close"
					tabindex="-1"
					class="flex items-center gap-x-2 hover:brightness-150"
					aria-label="button close"
				>
					<svg
						class="fill-[#7D704F]"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
						></path></svg
					>
					<span class="text-sm text-[#7D704F]"></span>
				</button>
			</div>
			<div>
				<a data-sveltekit-reload href="/" class="block h-16 md:h-24">
					<img
						class="block h-full mx-auto"
						src={items[0]?.logo_color[0].path}
						alt="Trans Resort Logo"
						loading="lazy"
					/>
				</a>
			</div>
			<div class="hidden lg:block">
				<a class="btn-primary py-3 px-5 uppercase" data-sveltekit-reload href={items[0].book_url}
					>Book Now</a
				>
			</div>
		</div>
		<div class="lg:grid lg:grid-cols-5">
			<div>
				<ul class="space-y-3 md:space-y-5">
					<li class="text-center lg:text-left">
						<a
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							data-sveltekit-reload
							href="/">Home</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							href="/room-villa">Rooms</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl" href="/offer"
							>Special Offers</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl" href="/dining"
							>Dining</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl" href="/leisure"
							>Leisure</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							href="/meeting-event">MICE</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl" href="/gallery"
							>Gallery</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							href="/thg-apps">THG Apps</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							href="/offer#Allo Bank Offers">Allo Bank</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							class="text-2xl font-serif text-[#7D704F] tracking-tight md:text-3xl"
							href="https://geckodigital.co/vt/Trans/">Virtual Tour</a
						>
					</li>
				</ul>
			</div>
			<div class="hidden lg:block lg:col-span-4 container">
				<div class="tabs">
					<!-- Tab Headers -->
					<div class="tab-headers flex gap-4">
						<button
							class={`px-4 py-2 rounded ${
								activeTab === 'room' ? 'bg-[#7d704f] text-[#f6f3eb]' : 'bg-[#f6f3eb] text-[#7d704f]'
							}`}
							on:click={() => (activeTab = 'room')}
						>
							Rooms
						</button>
						<button
							class={`px-4 py-2 rounded ${
								activeTab === 'specialOffers'
									? 'bg-[#7d704f] text-[#f6f3eb]'
									: 'bg-[#f6f3eb] text-[#7d704f]'
							}`}
							on:click={() => (activeTab = 'specialOffers')}
						>
							Special Offers
						</button>
					</div>

					<!-- Tab Contents -->
					<div class="tab-content mt-4">
						{#if activeTab === 'room'}
							<Splide
								options={{
									rewind: false,
									gap: 5,
									perPage: 2,
									type: 'slide',
									arrows: true,
									pagination: false
								}}
							>
								{#if rooms.length > 0}
									{#each rooms as room}
										<SplideSlide>
											<a
												href="/room-villa/{room?.slug}"
												aria-label="room"
												class="h-[320px] w-full rounded-xl overflow-hidden bg-cover bg-center bg-blend-overlay bg-black/40 p-6 flex flex-col"
												style="background-image: url({room?.images[0]?.path})"
											>
												<div class="mt-auto">
													<h2 class="text-white font-serif font-semibold text-left text-2xl">
														{room?.name}
													</h2>
													<ul class="text-white mt-2 font-light gap-x-2 flex items-center">
														<li class="flex items-center space-x-2">
															<svg
																class="w-4 h-4 fill-white"
																xmlns="http://www.w3.org/2000/svg"
																width="32"
																height="32"
																fill="#000000"
																viewBox="0 0 256 256"
																><path
																	d="M214,48V96a6,6,0,0,1-12,0V62.48l-53.76,53.76a6,6,0,0,1-8.48-8.48L193.52,54H160a6,6,0,0,1,0-12h48A6,6,0,0,1,214,48ZM107.76,139.76,54,193.52V160a6,6,0,0,0-12,0v48a6,6,0,0,0,6,6H96a6,6,0,0,0,0-12H62.48l53.76-53.76a6,6,0,0,0-8.48-8.48Z"
																></path></svg
															>
															<span class="text-xs">{room?.size}</span>
														</li>
														<li class="flex items-center space-x-2">
															<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="#ffffff" viewBox="0 0 256 256"><path d="M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z"></path></svg>
															<span class="text-xs">{room?.type}</span>
														</li>
														<li class="flex items-center space-x-2">
															<svg
																class="w-4 h-4 fill-white"
																xmlns="http://www.w3.org/2000/svg"
																width="32"
																height="32"
																fill="#000000"
																viewBox="0 0 256 256"
																><path
																	d="M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
																></path></svg
															>
															<span class="text-xs">{room?.occupancy}</span>
														</li>
													</ul>
												</div>
											</a>
										</SplideSlide>
									{/each}
								{/if}
							</Splide>
						{/if}
						{#if activeTab === 'specialOffers'}
							<Splide
								options={{
									rewind: false,
									gap: 5,
									perPage: 3,
									type: 'slide',
									arrows: true,
									pagination: false
								}}
							>
								{#if specialOffers.length > 0}
									{#each specialOffers.slice(0, 5) as offer}
										<SplideSlide>
											{#if offer?.type_button === 'Detail'}
												<a
													data-sveltekit-reload
													href="/offer/{offer?.slug}"
													class="aspect-square w-full bg-black/40 bg-blend-overlay bg-cover bg-center !rounded-xl overflow-hidden flex flex-col transition-all duration-300 hover:brightness-75"
													tabindex="-1"
												>
													<img
														class="object-cover object-center w-full h-full"
														alt="Transversary Celebration"
														src={offer?.images[0]?.path}
													/>
												</a>
											{:else}
												<a
													href="/offer"
													data-sveltekit-reload
													class="aspect-square w-full bg-black/40 bg-blend-overlay bg-cover bg-center !rounded-xl overflow-hidden flex flex-col transition-all duration-300 hover:brightness-75"
													tabindex="-1"
												>
													<img
														class="object-cover object-center w-full h-full"
														alt="Transversary Celebration"
														src={offer?.images[0]?.path}
													/>
												</a>
											{/if}
										</SplideSlide>
									{/each}
								{/if}
							</Splide>
						{/if}
					</div>
				</div>
			</div>
		</div>
		<div class="text-[#7D704F] grid grid-cols-3">
			<div class="col-span-2 ms-auto">
				<ul class="space-y-1 text-center">
					<li>
						<a
							data-sveltekit-reload
							href="https://www.google.com/search?q=The+Trans+Resort+Bali"
							target="_blank"
							class="flex items-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-center"
						>
							<svg
								class="w-4 h-4 block fill-[#7D704F]"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z"
								></path></svg
							>
							<span> {items[0]?.address} </span>
						</a>
					</li>
					{#each items[0].email as item}
						<li>
							<a
								data-sveltekit-reload
								href="mailto:reservation.bali@thetranshotel.com"
								class="flex items-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-center"
							>
								<svg
									class="w-4 h-4 block fill-[#7D704F]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50ZM208.58,62,128,135.86,47.42,62ZM216,194H40a2,2,0,0,1-2-2V69.64l86,78.78a6,6,0,0,0,8.1,0L218,69.64V192A2,2,0,0,1,216,194Z"
									></path></svg
								>
								<span>{item.item} </span>
							</a>
						</li>
					{/each}
					{#each items[0].phone as item}
						<li>
							<a
								data-sveltekit-reload
								href="tel:{item?.number}"
								class="flex items-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-center"
							>
								<svg
									class="w-4 h-4 block fill-[#7D704F]"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									fill="#000000"
									viewBox="0 0 256 256"
									><path
										d="M221.59,160.3l-47.24-21.17a14,14,0,0,0-13.28,1.22,4.81,4.81,0,0,0-.56.42l-24.69,21a1.88,1.88,0,0,1-1.68.06c-15.87-7.66-32.31-24-40-39.65a1.91,1.91,0,0,1,0-1.68l21.07-25a6.13,6.13,0,0,0,.42-.58,14,14,0,0,0,1.12-13.27L95.73,34.49a14,14,0,0,0-14.56-8.38A54.24,54.24,0,0,0,34,80c0,78.3,63.7,142,142,142a54.25,54.25,0,0,0,53.89-47.17A14,14,0,0,0,221.59,160.3ZM176,210C104.32,210,46,151.68,46,80A42.23,42.23,0,0,1,82.67,38h.23a2,2,0,0,1,1.84,1.31l21.1,47.11a2,2,0,0,1,0,1.67L84.73,113.15a4.73,4.73,0,0,0-.43.57,14,14,0,0,0-.91,13.73c8.87,18.16,27.17,36.32,45.53,45.19a14,14,0,0,0,13.77-1c.19-.13.38-.27.56-.42l24.68-21a1.92,1.92,0,0,1,1.6-.1l47.25,21.17a2,2,0,0,1,1.21,2A42.24,42.24,0,0,1,176,210Z"
									></path></svg
								>
								<span> +{item?.number} </span>
							</a>
						</li>
					{/each}
				</ul>
			</div>
			<div
				class="col-span-1 mt-4 flex items-center justify-center divide-x divide-[#7D704F] lg:mt-0"
			>
				<ul class="flex items-center pl-2.5 gap-x-2 h-6 lg:gap-x-3 lg:pl-4">
					{#each items[0]?.social_media as item}
						<li>
							<a
								class="w-5 block lg:w-8"
								target="_blank"
								aria-label={item.item}
								data-sveltekit-reload
								href={item.tautan}
							>
								{#if item.item === 'Instagram'}
									<svg
										class="block w-full fill-[#7D704F] h-5 lg:h-7"
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										fill="#000000"
										viewBox="0 0 256 256"
									>
										<path
											d="M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162ZM176,26H80A54.06,54.06,0,0,0,26,80v96a54.06,54.06,0,0,0,54,54h96a54.06,54.06,0,0,0,54-54V80A54.06,54.06,0,0,0,176,26Zm42,150a42,42,0,0,1-42,42H80a42,42,0,0,1-42-42V80A42,42,0,0,1,80,38h96a42,42,0,0,1,42,42ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"
										></path>
									</svg>
								{:else if item.item === 'Facebook'}
									<svg
										class="bloc w-full fill-[#7D704F]"
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										fill="#000000"
										viewBox="0 0 256 256"
									>
										<path
											d="M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm6,191.8V150h26a6,6,0,0,0,0-12H134V112a18,18,0,0,1,18-18h16a6,6,0,0,0,0-12H152a30,30,0,0,0-30,30v26H96a6,6,0,0,0,0,12h26v67.8a90,90,0,1,1,12,0Z"
										></path>
									</svg>
								{:else if item.item === 'Whatsapp'}
									<svg
										class="block w-full fill-[#7D704F] h-5 lg:h-7"
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										fill="#000000"
										viewBox="0 0 256 256"
										><path
											d="M186.68,146.63l-32-16a6,6,0,0,0-6,.38L133,141.46A42.49,42.49,0,0,1,114.54,123L125,107.33a6,6,0,0,0,.38-6l-16-32A6,6,0,0,0,104,66a38,38,0,0,0-38,38,86.1,86.1,0,0,0,86,86,38,38,0,0,0,38-38A6,6,0,0,0,186.68,146.63ZM152,178a74.09,74.09,0,0,1-74-74,26,26,0,0,1,22.42-25.75l12.66,25.32-10.39,15.58a6,6,0,0,0-.54,5.63,54.43,54.43,0,0,0,29.07,29.07,6,6,0,0,0,5.63-.54l15.58-10.39,25.32,12.66A26,26,0,0,1,152,178ZM128,26A102,102,0,0,0,38.35,176.69L26.73,211.56a14,14,0,0,0,17.71,17.71l34.87-11.62A102,102,0,1,0,128,26Zm0,192a90,90,0,0,1-45.06-12.08,6.09,6.09,0,0,0-3-.81,6.2,6.2,0,0,0-1.9.31L40.65,217.88a2,2,0,0,1-2.53-2.53L50.58,178a6,6,0,0,0-.5-4.91A90,90,0,1,1,128,218Z"
										></path></svg
									>
								{:else if item.item === 'Youtube'}
									<svg
										class="block w-full fill-[#7D704F] h-5 lg:h-7"
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										fill="#000000"
										viewBox="0 0 256 256"
									>
										<path
											d="M163.33,123l-48-32A6,6,0,0,0,106,96v64a6,6,0,0,0,9.33,5l48-32a6,6,0,0,0,0-10ZM118,148.79V107.21L149.18,128ZM232.4,70a22,22,0,0,0-13.28-15C185,41.79,130.27,42,128,42s-57-.21-91.16,13A22,22,0,0,0,23.6,70C21.05,79.89,18,98,18,128s3.05,48.11,5.6,58a22,22,0,0,0,13.28,15C71,214.21,125.72,214,128,214h.71c6.91,0,58-.44,90.45-13a22,22,0,0,0,13.28-15c2.55-9.87,5.6-27.93,5.6-58S235,79.89,232.4,70ZM220.78,183a10,10,0,0,1-6,6.86C182.78,202.19,128.58,202,128,202s-54.71.2-86.75-12.17a10,10,0,0,1-6-6.86C32.84,173.78,30,156.78,30,128s2.84-45.78,5.22-55a10,10,0,0,1,6-6.86C72.06,54.26,123.53,54,127.76,54H128c.54,0,54.71-.2,86.75,12.17a10,10,0,0,1,6,6.86c2.38,9.19,5.22,26.19,5.22,55S223.16,173.78,220.78,183Z"
										></path>
									</svg>
								{:else if item.item === 'Tripadvisor'}
									<svg
										class="block w-full fill-[#7D704F] h-5 lg:h-7"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink"
										x="0px"
										y="0px"
										viewBox="0 0 800 487.5"
										style="enable-background:new 0 0 800 487.5;"
										xml:space="preserve"
										><g
											><path
												d="M795.7,99.9c4.3-4.3,5.5-10.6,3.2-16.1c-2.3-5.6-7.7-9.1-13.7-9.1H666.8c-29-20-58.6-35.5-90.5-47.5 C524.4,7.6,466.7-1.9,400-1.9c-66.7,0-124.4,9.5-176.3,29c-31.9,12-61.5,27.5-90.5,47.5H14.8c-6,0-11.4,3.6-13.7,9.1 c-2.3,5.6-1,11.9,3.2,16.1l46.4,46.4C18,184,0,232,0,282c0,114.4,93,207.4,207.4,207.4c50,0,98-18,135.7-50.7l46.4,46.4 c2.8,2.8,6.5,4.3,10.5,4.3c4,0,7.7-1.5,10.5-4.3l46.4-46.4c37.7,32.7,85.8,50.7,135.7,50.7C707,489.4,800,396.4,800,282 c0-50-18-98-50.7-135.7L795.7,99.9z M435.9,417.8L400,453.7l-35.9-35.9c15.3-17.6,27.3-37.3,35.9-58.8 C408.6,380.5,420.6,400.2,435.9,417.8z M71.4,125.1l-20.8-20.8h44C86.8,110.8,79,117.8,71.4,125.1z M592.6,74.6 c-44.6,0-87.2,14-123,40.5c-17.2,12.8-32.4,28-45,45.4c-10,13.8-18.3,28.8-24.6,44.5c-6.3-15.8-14.6-30.7-24.6-44.5 c-12.6-17.4-27.7-32.6-45-45.4c-35.9-26.5-78.4-40.5-123-40.5c-6.1,0-12.3,0.3-18.4,0.8C250.1,43,317.9,27.7,400,27.7 c82.1,0,149.9,15.2,211,47.7C604.9,74.9,598.7,74.6,592.6,74.6z M385.2,282c0,98-79.7,177.8-177.8,177.8 c-98,0-177.8-79.7-177.8-177.8s79.7-177.8,177.8-177.8C305.4,104.2,385.2,184,385.2,282z M770.4,282c0,98-79.7,177.8-177.8,177.8 c-98,0-177.8-79.7-177.8-177.8s79.7-177.8,177.8-177.8C690.6,104.2,770.4,184,770.4,282z M705.4,104.2h44l-20.8,20.8 C721,117.8,713.2,110.8,705.4,104.2z"
											></path><path
												d="M207.4,206.4c-41.7,0-75.6,33.9-75.6,75.6c0,41.7,33.9,75.6,75.6,75.6S283,323.7,283,282 C283,240.3,249.1,206.4,207.4,206.4z M253.4,282c0,25.4-20.6,46-46,46s-46-20.6-46-46c0-25.4,20.6-46,46-46S253.4,256.7,253.4,282z"
											></path><path
												d="M592.6,206.4c-41.7,0-75.6,33.9-75.6,75.6c0,41.7,33.9,75.6,75.6,75.6s75.6-33.9,75.6-75.6 C668.2,240.3,634.3,206.4,592.6,206.4z M638.6,282c0,25.4-20.6,46-46,46s-46-20.6-46-46c0-25.4,20.6-46,46-46 S638.6,256.7,638.6,282z"
											></path></g
										></svg
									>
								{/if}
							</a>
						</li>
					{/each}
				</ul>
			</div>
		</div>
	</div>
</Drawer>
<Drawer
	placement="right"
	transitionType="fly"
	transitionParams={transitionParamsRight}
	bind:hidden={hidden6}
	id="sidebar6"
	class="w-full"
>
	<div class="flex items-center">
		<CloseButton on:click={() => (hidden6 = true)} class="mb-4 dark:text-white" />
	</div>
	<div class="w-ful data-sveltekit-reloadl h-full flex flex-col justify-between p-5 md:p-10">
		<div class="mx-auto">
			<a href="/" class="block h-16 md:h-24">
				<img
					class="block h-full mx-auto"
					src="/images/logo-color.webp"
					alt="Trans Resort Logo"
					loading="lazy"
				/>
			</a>
		</div>
		<div class="lg:grid lg:grid-cols-5">
			<div>
				<ul class="space-y-3 md:space-y-5">
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/">Home</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/room-villa">Rooms</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/offer">Special Offers</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/dining">Dining</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/leisure">Leisure</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/meeting-event">MICE</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/gallery">Gallery</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/thg-apps">THG Apps</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="/offer#Allo Bank Offers">Allo Bank</a
						>
					</li>
					<li class="text-center lg:text-left">
						<a
							data-sveltekit-reload
							class="text-2xl font-serif text-mindigold tracking-tight md:text-3xl"
							href="https://geckodigital.co/vt/Trans/">Vitrtual Tour</a
						>
					</li>
				</ul>
			</div>
		</div>
		<div class="text-mindigold lg:flex lg:items-center lg:justify-between">
			<div>
				<ul class="space-y-1">
					<li>
						<a
							href="https://www.google.com/search?q=The+Trans+Resort+Bali"
							target="_blank"
							class="flex items-center text-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-start"
						>
							<svg
								class="w-4 h-4 block fill-mindigold"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z"
								></path></svg
							>
							<span> Sunset Road, Seminyak-Kerobokan, Bali, Indonesia </span>
						</a>
					</li>
					<li>
						<a
							href="mailto:reservation.bali@thetranshotel.com"
							class="flex items-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-start"
						>
							<svg
								class="w-4 h-4 block fill-mindigold"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50ZM208.58,62,128,135.86,47.42,62ZM216,194H40a2,2,0,0,1-2-2V69.64l86,78.78a6,6,0,0,0,8.1,0L218,69.64V192A2,2,0,0,1,216,194Z"
								></path></svg
							>
							<span> reservation.bali@thetranshotel.com </span>
						</a>
					</li>
					<li>
						<a
							href="tel:623618981234"
							class="flex items-center justify-center gap-x-1.5 text-xs lg:text-sm lg:justify-start"
						>
							<svg
								class="w-4 h-4 block fill-mindigold"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M221.59,160.3l-47.24-21.17a14,14,0,0,0-13.28,1.22,4.81,4.81,0,0,0-.56.42l-24.69,21a1.88,1.88,0,0,1-1.68.06c-15.87-7.66-32.31-24-40-39.65a1.91,1.91,0,0,1,0-1.68l21.07-25a6.13,6.13,0,0,0,.42-.58,14,14,0,0,0,1.12-13.27L95.73,34.49a14,14,0,0,0-14.56-8.38A54.24,54.24,0,0,0,34,80c0,78.3,63.7,142,142,142a54.25,54.25,0,0,0,53.89-47.17A14,14,0,0,0,221.59,160.3ZM176,210C104.32,210,46,151.68,46,80A42.23,42.23,0,0,1,82.67,38h.23a2,2,0,0,1,1.84,1.31l21.1,47.11a2,2,0,0,1,0,1.67L84.73,113.15a4.73,4.73,0,0,0-.43.57,14,14,0,0,0-.91,13.73c8.87,18.16,27.17,36.32,45.53,45.19a14,14,0,0,0,13.77-1c.19-.13.38-.27.56-.42l24.68-21a1.92,1.92,0,0,1,1.6-.1l47.25,21.17a2,2,0,0,1,1.21,2A42.24,42.24,0,0,1,176,210Z"
								></path></svg
							>
							<span> +623618981234 </span>
						</a>
					</li>
				</ul>
			</div>
			<div class="mt-4 flex items-center justify-center divide-x divide-mindigold lg:mt-0">
				<ul class="flex items-center pl-2.5 gap-x-2 h-6 lg:gap-x-3 lg:pl-4">
					<li>
						<a
							class="w-5 block lg:w-8"
							aria-label="navigation"
							target="_blank"
							href="https://wa.me/6281138008889"
						>
							<svg
								class="block w-full fill-mindigold h-5 lg:h-7"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M186.68,146.63l-32-16a6,6,0,0,0-6,.38L133,141.46A42.49,42.49,0,0,1,114.54,123L125,107.33a6,6,0,0,0,.38-6l-16-32A6,6,0,0,0,104,66a38,38,0,0,0-38,38,86.1,86.1,0,0,0,86,86,38,38,0,0,0,38-38A6,6,0,0,0,186.68,146.63ZM152,178a74.09,74.09,0,0,1-74-74,26,26,0,0,1,22.42-25.75l12.66,25.32-10.39,15.58a6,6,0,0,0-.54,5.63,54.43,54.43,0,0,0,29.07,29.07,6,6,0,0,0,5.63-.54l15.58-10.39,25.32,12.66A26,26,0,0,1,152,178ZM128,26A102,102,0,0,0,38.35,176.69L26.73,211.56a14,14,0,0,0,17.71,17.71l34.87-11.62A102,102,0,1,0,128,26Zm0,192a90,90,0,0,1-45.06-12.08,6.09,6.09,0,0,0-3-.81,6.2,6.2,0,0,0-1.9.31L40.65,217.88a2,2,0,0,1-2.53-2.53L50.58,178a6,6,0,0,0-.5-4.91A90,90,0,1,1,128,218Z"
								></path></svg
							>
						</a>
					</li>
					<li>
						<a
							class="w-5 block lg:w-8"
							target="_blank"
							aria-label="navigation"
							href="https://www.facebook.com/thetransresortbali/?rf=513256195393338"
						>
							<svg
								class="bloc w-full fill-mindigold"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm6,191.8V150h26a6,6,0,0,0,0-12H134V112a18,18,0,0,1,18-18h16a6,6,0,0,0,0-12H152a30,30,0,0,0-30,30v26H96a6,6,0,0,0,0,12h26v67.8a90,90,0,1,1,12,0Z"
								></path></svg
							>
						</a>
					</li>
					<li>
						<a
							class="w-5 block lg:w-8"
							target="_blank"
							aria-label="navigation"
							href="https://www.youtube.com/@TheTransResortBali"
						>
							<svg
								class="block w-full fill-mindigold h-5 lg:h-7"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M163.33,123l-48-32A6,6,0,0,0,106,96v64a6,6,0,0,0,9.33,5l48-32a6,6,0,0,0,0-10ZM118,148.79V107.21L149.18,128ZM232.4,70a22,22,0,0,0-13.28-15C185,41.79,130.27,42,128,42s-57-.21-91.16,13A22,22,0,0,0,23.6,70C21.05,79.89,18,98,18,128s3.05,48.11,5.6,58a22,22,0,0,0,13.28,15C71,214.21,125.72,214,128,214h.71c6.91,0,58-.44,90.45-13a22,22,0,0,0,13.28-15c2.55-9.87,5.6-27.93,5.6-58S235,79.89,232.4,70ZM220.78,183a10,10,0,0,1-6,6.86C182.78,202.19,128.58,202,128,202s-54.71.2-86.75-12.17a10,10,0,0,1-6-6.86C32.84,173.78,30,156.78,30,128s2.84-45.78,5.22-55a10,10,0,0,1,6-6.86C72.06,54.26,123.53,54,127.76,54H128c.54,0,54.71-.2,86.75,12.17a10,10,0,0,1,6,6.86c2.38,9.19,5.22,26.19,5.22,55S223.16,173.78,220.78,183Z"
								></path></svg
							>
						</a>
					</li>
					<li>
						<a
							class="w-5 block lg:w-8"
							target="_blank"
							aria-label="navigation"
							href="https://www.instagram.com/thetransresortbali/"
						>
							<svg
								class="block w-full fill-mindigold h-5 lg:h-7"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162ZM176,26H80A54.06,54.06,0,0,0,26,80v96a54.06,54.06,0,0,0,54,54h96a54.06,54.06,0,0,0,54-54V80A54.06,54.06,0,0,0,176,26Zm42,150a42,42,0,0,1-42,42H80a42,42,0,0,1-42-42V80A42,42,0,0,1,80,38h96a42,42,0,0,1,42,42ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"
								></path></svg
							>
						</a>
					</li>
					<li>
						<a
							class="w-5 block lg:w-8"
							target="_blank"
							aria-label="navigation"
							href="https://www.tripadvisor.com/Hotel_Review-g13356179-d7368654-Reviews-The_Trans_Resort_Bali-Kerobokan_Kelod_North_Kuta_Bali.html"
						>
							<svg
								class="block w-full fill-mindigold h-5 lg:h-7"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								x="0px"
								y="0px"
								viewBox="0 0 800 487.5"
								style="enable-background:new 0 0 800 487.5;"
								xml:space="preserve"
								><g
									><path
										d="M795.7,99.9c4.3-4.3,5.5-10.6,3.2-16.1c-2.3-5.6-7.7-9.1-13.7-9.1H666.8c-29-20-58.6-35.5-90.5-47.5 C524.4,7.6,466.7-1.9,400-1.9c-66.7,0-124.4,9.5-176.3,29c-31.9,12-61.5,27.5-90.5,47.5H14.8c-6,0-11.4,3.6-13.7,9.1 c-2.3,5.6-1,11.9,3.2,16.1l46.4,46.4C18,184,0,232,0,282c0,114.4,93,207.4,207.4,207.4c50,0,98-18,135.7-50.7l46.4,46.4 c2.8,2.8,6.5,4.3,10.5,4.3c4,0,7.7-1.5,10.5-4.3l46.4-46.4c37.7,32.7,85.8,50.7,135.7,50.7C707,489.4,800,396.4,800,282 c0-50-18-98-50.7-135.7L795.7,99.9z M435.9,417.8L400,453.7l-35.9-35.9c15.3-17.6,27.3-37.3,35.9-58.8 C408.6,380.5,420.6,400.2,435.9,417.8z M71.4,125.1l-20.8-20.8h44C86.8,110.8,79,117.8,71.4,125.1z M592.6,74.6 c-44.6,0-87.2,14-123,40.5c-17.2,12.8-32.4,28-45,45.4c-10,13.8-18.3,28.8-24.6,44.5c-6.3-15.8-14.6-30.7-24.6-44.5 c-12.6-17.4-27.7-32.6-45-45.4c-35.9-26.5-78.4-40.5-123-40.5c-6.1,0-12.3,0.3-18.4,0.8C250.1,43,317.9,27.7,400,27.7 c82.1,0,149.9,15.2,211,47.7C604.9,74.9,598.7,74.6,592.6,74.6z M385.2,282c0,98-79.7,177.8-177.8,177.8 c-98,0-177.8-79.7-177.8-177.8s79.7-177.8,177.8-177.8C305.4,104.2,385.2,184,385.2,282z M770.4,282c0,98-79.7,177.8-177.8,177.8 c-98,0-177.8-79.7-177.8-177.8s79.7-177.8,177.8-177.8C690.6,104.2,770.4,184,770.4,282z M705.4,104.2h44l-20.8,20.8 C721,117.8,713.2,110.8,705.4,104.2z"
									></path><path
										d="M207.4,206.4c-41.7,0-75.6,33.9-75.6,75.6c0,41.7,33.9,75.6,75.6,75.6S283,323.7,283,282 C283,240.3,249.1,206.4,207.4,206.4z M253.4,282c0,25.4-20.6,46-46,46s-46-20.6-46-46c0-25.4,20.6-46,46-46S253.4,256.7,253.4,282z"
									></path><path
										d="M592.6,206.4c-41.7,0-75.6,33.9-75.6,75.6c0,41.7,33.9,75.6,75.6,75.6s75.6-33.9,75.6-75.6 C668.2,240.3,634.3,206.4,592.6,206.4z M638.6,282c0,25.4-20.6,46-46,46s-46-20.6-46-46c0-25.4,20.6-46,46-46 S638.6,256.7,638.6,282z"
									></path></g
								></svg
							>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</Drawer>
